$(function() {
    const $dashboardMembershipPage = $('.DashboardMembershipPage'),
        $dashboardProfilePage = $('.DashboardProfilePage');
    if (!$dashboardMembershipPage.length && !$dashboardProfilePage.length) return false;

    const $membershipPaymentForm = $('#MembershipPaymentsForm_MembershipPaymentsForm'),
        $ccRadio = $('#RadioCreditCard'),
        $ccSubMethods = $('#step2-Credit'),
        $ccRadioNew = $('#RadioNewCreditCard'),
        $ccTokenRadio = $('#RadioToken'),
        $btnSave = $('#btn-save');

    $('.form-default').on('click', '.payment-method-radio', function() {
        const paymentMethodValue = $(this).val();

        $('.payment-method-form').hide();
        $('#step2-' + paymentMethodValue)
            .stop()
            .show('fast');

        if (paymentMethodValue === 'Credit' && $ccSubMethods.length) {
            $('#RadioToken').click();
        } else {
            $('.step2-sub').hide();
            $('#step2-sub-' + paymentMethodValue)
                .stop()
                .show('fast');
            $('#btnPayNow').prop('disabled', false);
        }
    });

    $('.form-default').on('click', '.payment-sub-method-radio', function() {
        const paymentSubMethodValue = $(this).val();

        $('.step2-sub').hide();
        $('#step2-sub-' + paymentSubMethodValue)
            .stop()
            .show('fast');
        $('#btnPayNow').prop('disabled', false);
    });

    if ($membershipPaymentForm.length) {
        $membershipPaymentForm.parsley().subscribe('parsley:form:validate', function(formInstance) {
            if ($ccRadio.is(':checked') || $paypal.is(':checked') || $voucher.is(':checked')) {
                if ($ccRadio.is(':checked')) {
                    if ($ccRadioNew.length) {
                        if ($ccRadioNew.length && $ccRadioNew.is(':checked') && formInstance.isValid('Credit', true)) {
                            $btnSave.prop('disabled', true);
                            $btnSave.text(hpaTranslatedtext.payment.processingText); // Processing...
                        } else if ($ccTokenRadio.length && $ccTokenRadio.is(':checked')) {
                            $btnSave.addClass('btn-success').removeClass('btn-primary');
                            $btnSave.prop('disabled', true);
                            $btnSave.text(hpaTranslatedtext.dashboardMembershipPage.changesSaved); // Changes Saved!
                            setTimeout(function () {
                                $btnSave.removeClass('btn-success').addClass('btn-primary');
                                $btnSave.prop('disabled', false);
                                $btnSave.text(hpaTranslatedtext.dashboardMembershipPage.saveChanges); // Save Changes
                            }, 2000);
                        }
                    } else if (formInstance.isValid('Credit', true)) {
                        $btnSave.prop('disabled', true);
                        $btnSave.text(hpaTranslatedtext.payment.processingText); // Processing...
                    }

                    return true;
                }
                // else if ($paypal.is(':checked') && formInstance.isValid('PayPal', true)) {
                //     $btnSave.prop('disabled', true);
                //     $btnSave.text('Processing...');
                //     return true;
                // } else if ($voucher.is(':checked') && formInstance.isValid('Voucher', true)) {
                //     $btnSave.prop('disabled', true);
                //     $btnSave.text('Processing...');
                //     return true;
                // }
            }

            // else stop form submission
            formInstance.submitEvent.preventDefault();

            return false;
        });
    }

    $ccRadio.trigger('click');
    $ccRadioNew.trigger('click');

});



// WEBPACK FOOTER //
// ./js/modules/dashboardMembershipPage.js